import React, { useState, useEffect } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { Link, useNavigate } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import Swal from "sweetalert2";

function Etik() {
    const navigate = useNavigate();
    const [kodeEtik, setKodeEtik] = useState([]);

    const fetchData = async () => {
        try {
            const token = localStorage.getItem("token");
            if (!token) {
                navigate("/");
                return;
            }

            axios.interceptors.request.use(
                (config) => {
                    config.headers.authorization = token;
                    return config;
                },
                (error) => Promise.reject(error)
            );

            const response = await axios.get(`${process.env.REACT_APP_API_URL}/etik/readKodeEtik`);

            setKodeEtik(response.data);
        } catch (error) {
            console.error("Error:", error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleDelete = async (id) => {
        Swal.fire({
            title: "Warning",
            text: "Apakah yakin ingin menghapus data ini?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Ya, hapus!",
            cancelButtonText: "Batal",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await axios.delete(
                        `${process.env.REACT_APP_API_URL}/etik/deleteKodeEtik/${id}`
                    );

                    fetchData();

                    Swal.fire("Dihapus!", "Data berhasil dihapus.", "success");
                } catch (error) {
                    console.error("Error deleting:", error);
                    Swal.fire("Error!", "Terjadi kesalahan saat menghapus data.", "error");
                }
            }
        });
    };

    const columns = [
        {
            name: "No",
            selector: (row, index) => index + 1,
            width: "70px",
        },
        {
            name: "Foto",
            selector: (row) => (
                <img
                    src={row.foto}
                    alt="WBS"
                    style={{ width: "100px", height: "70px", objectFit: "cover" }}
                />
            ),
        },
        {
            name: "Deskripsi",
            selector: (row) => row.deskripsi,
            width: "200px",
        },
        {
            name: "Dokumen",
            selector: (row) => (
                <a href={row.dokumen} target="_blank" rel="noopener noreferrer">
                    Lihat Dokumen
                </a>
            ),
        },
        {
            name: "Aksi",
            cell: (row) => (
                <>
                    <Link to={`/kodeEtikEdit/${row.id}`} className="btn btn-warning mr-2">
                        <i className="nav-icon fas fa-edit" />
                    </Link>

                    <button onClick={() => handleDelete(row.id)} className="btn btn-danger">
                        <i className="nav-icon fas fa-trash" />
                    </button>
                </>
            ),
        },
    ];

    return (
        <div className="wrapper">
            <Header />
            <Navbar />

            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Kode Etik</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item">
                                        <a href="/#">Administrasi</a>
                                    </li>
                                    <li className="breadcrumb-item active">Kode Etik</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header d-flex justify-content-between">
                                        <h3 className="card-title">Data Kode Etik</h3>

                                        {kodeEtik.length === 0 && (
                                            <Link to="/kodeEtikAdd" className="btn btn-primary">
                                                <i className="nav-icon fas fa-plus mr-2" />
                                                Tambah Data
                                            </Link>
                                        )}
                                    </div>

                                    <div className="card-body">
                                        <DataTable columns={columns} data={kodeEtik} pagination />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default Etik;
